module.exports = __webpack_public_path__ + "assets/eyeOpen.26bf09f4.svg";